import cn from 'classnames'
import { memo, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { promotionProductTranslationKey } from '../../configs/translation'
import { OfferTypeMarker } from '../../models'

import { OfferMarker } from './OfferMarker'

import styles from './OfferMarkerList.module.scss'

interface Props {
  readonly markers: readonly OfferTypeMarker[]
  readonly className?: string
}

const MARKER_ORDER: readonly OfferTypeMarker[] = ['deal', 'hot_offer', 'end_customer']

export const OfferMarkerList = memo<Props>(({ markers, className }) => {
  const { t } = useTranslation()
  const visibleMarkers = useMemo(() => {
    const availableMarkers = new Set(markers)

    return MARKER_ORDER.filter((marker) => availableMarkers.has(marker))
  }, [markers])

  if (visibleMarkers.length === 0) {
    return null
  }

  return (
    <div
      className={cn(styles.root, className)}
      role="group"
      aria-label={t(`${promotionProductTranslationKey}-offer-types`)}
    >
      {visibleMarkers.map((marker) => (
        <OfferMarker key={marker} type={marker} />
      ))}
    </div>
  )
})

OfferMarkerList.displayName = 'OfferMarkerList'
